export default "__VITE_ASSET__DhJz8KFK__"